export default {
    billboard: 'Billboard',
    createMessage: 'Create Message',
    startDate: 'Start Date',
    endDate: 'End Date',
    topic: 'Topic',
    searchByTopic: 'Search By Topic',
    search: 'Search',
    deleteMessage: 'Delete Message',
    congratulation: 'Congratulation',
    msgDeleteSuccess: 'Message billboard is deleted.',
    questionDelete: 'Are you sure to delete "$Name"?'
}
